import { render, staticRenderFns } from "./LocalFileUploader.vue?vue&type=template&id=174a88f0&scoped=true"
import script from "./LocalFileUploader.vue?vue&type=script&lang=js"
export * from "./LocalFileUploader.vue?vue&type=script&lang=js"
import style0 from "./LocalFileUploader.vue?vue&type=style&index=0&id=174a88f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174a88f0",
  null
  
)

export default component.exports